import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { space } from '../spark/tokens';
import accordion from './accordion';
import alert from './alert';
import avatar from './avatar';
import badge from './badge';
import booleanInput from './boolean-input';
import breadcrumbs from './breadcrumbs';
import button from './button';
import card from './card';
import { colors, sparkColors as sparkColors_ } from './colors';
import drawer from './drawer';
import dropdown from './dropdown';
import input from './input';
import link from './link';
import list from './list';
import modal from './modal';
import overlay from './overlay';
import pagination from './pagination';
import popover from './popover';
import rating from './rating';
import select from './select';
import slider from './slider';
import spinner from './spinner';
import table from './table';
import tabs from './tabs';
import tag from './tag';
import toast from './toast';
import tooltip from './tooltip';
import typography, { typeStyles } from './type';
export var sparkColors = sparkColors_;
export var fonts = {
  base: 'Inter, Roboto, "Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
  link: 'Inter, Roboto, "Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
  body: 'Inter, Roboto, "Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
  heading: '"Founders Grotesk", Inter, Roboto, "Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
  monospace: 'Menlo, monospace'
};
var lineHeights = {
  h_fg_md: 1.2,
  h_md: 1.17,
  h_lg: 1.14,
  h_xl: 1.11,
  h_xxl: 1.1,
  h_xxxl: 1.08,
  h_4xl: 1.07
};
var fontSizes = {
  base: 16,
  xxxxs: 10,
  xxxs: 12,
  xxs: 14,
  xs: 16,
  sm: 18,
  fg_md: 20,
  md: 24,
  lg: 28,
  xl: 36,
  xxl: 40,
  xxxl: 48,
  '4xl': 56,
  '5xl': 76,
  '6xl': 92
};
export var uswitchTheme = {
  meta: {
    isSparkBase: false
  },
  // Overwrite trustyle theme space tokens
  space: space,
  colors: colors,
  shadows: {
    radioFocus: "0px 0px 0px 2px ".concat(colors.yellow_primary),
    radioChecked: "inset 0px 0px 0px 1px rgba(20, 20, 20, 1)"
  },
  styles: _objectSpread({
    root: {
      overflowX: 'visible'
    }
  }, typeStyles),
  fonts: fonts,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  spark: {
    element: {
      type: typography,
      accordion: accordion,
      alert: alert,
      avatar: avatar,
      badge: badge,
      booleanInput: booleanInput,
      breadcrumbs: breadcrumbs,
      button: button,
      card: card,
      drawer: drawer,
      dropdown: dropdown,
      input: input,
      link: link,
      list: list,
      modal: modal,
      overlay: overlay,
      pagination: pagination,
      popover: popover,
      rating: rating,
      select: select,
      slider: slider,
      spinner: spinner,
      table: table,
      tabs: tabs,
      tag: tag,
      toast: toast,
      tooltip: tooltip
    }
  }
};